import React, { createContext, Dispatch, SetStateAction, useState } from "react";
export type scrollEvent = React.UIEventHandler<HTMLDivElement>;

export type scrollProps = {
  handleScroll?: React.UIEventHandler<HTMLDivElement>;
  readTermsOfUse?: boolean;
  setReadTermsOfUse?: Dispatch<SetStateAction<boolean>>;
};

export const ScrollContext = createContext<scrollProps>({});
export const ScrollContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [readTermsOfUse, setReadTermsOfUse] = useState(false);

  const handleScroll: React.UIEventHandler<HTMLDivElement> = e => {
    if (!readTermsOfUse) {
      const bottom = e.currentTarget.scrollHeight - e.currentTarget.scrollTop - e.currentTarget.clientHeight <= 1;
      if (bottom) {
        setReadTermsOfUse(true);
      }
    }
  };

  return (
    <ScrollContext.Provider value={{ readTermsOfUse, setReadTermsOfUse, handleScroll }}>
      {children}
    </ScrollContext.Provider>
  );
};
